import React, { useRef } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { _ } from '../../functions/translator.js';
import { PiCardsThree  } from "react-icons/pi";
import { CircularProgress } from '@material-ui/core'
import { postDataBlob } from '../../functions/postData.js';

function ExportCardsButton(){
    const { selectedCardsGroups } = useSelector(state => ({
        selectedCardsGroups: state.selectedCardsGroups,
    }))
    const [showLoading, setShowLoading] = useState(false);

    const buttonRef = useRef(null);

    const handleSubmit = async () => {
        setShowLoading(true)
        try {
            let urlPost = {
                project_id: window.project_id,
                cards_group_ids: selectedCardsGroups,
            }
            const response = await postDataBlob('/export-cards', urlPost, 'Error en la solicitud')
            if (response) {
                const urlBlob = window.URL.createObjectURL(response)
                const link = document.createElement('a');
                link.href = urlBlob;
                link.download = 'revisiones.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error('Error al exportar:', response);
            }

        } catch (error) {
            console.error('Error:', error);
        } finally {
            setShowLoading(false)
        }
    };

    return(
        <div className="popup-menu-button card-color" ref={buttonRef} >
            <div className='w-100' onClick={handleSubmit}>
                <div className='w-100 mt-2 d-inline-flex d-flex flex-row align-items-center justify-content-between'>
                    <div style={{width:'25px', height:'100%', position:'relative', left:'10px', marginRight:'2.5px', marginLeft:'2.5px'}}>
                        <PiCardsThree size={30}/>
                    </div>
                    <div className='w-100 d-flex justify-content-center align-items-center'>
                        <p className='m-0'>{ _('Exportar Revisiones') }</p>
                        {showLoading && 
                            <div style={{ position: 'absolute', right: '10px', top: '20%' }}>
                                <CircularProgress style={{ width:'20px', height:'20px' }} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExportCardsButton